import { Box } from '@locus-taxy/encore-mui';
import CustomAppEntityHeader from '../components/EntityDetails/CustomAppEntityHeader';
import { NetworkMapDetailsContainer } from '../components/EntityDetails/NetworkMapDetailsContainer';
import type { EntityDetailsAction } from '../types/actions';

interface NetworkMapDetailsPageContainerProps {
  entityName?: string;
  entityId?: string;
  entityNameToShow?: string;
  entityTitle?: string;
  entityData?: Record<string, unknown>;
  actions?: EntityDetailsAction[];
  onActionClick?: (action: EntityDetailsAction) => void;
  onViewSchema?: () => void;
}

export const NetworkMapDetailsPageContainer = ({
  entityName = 'networkMap',
  entityId = '',
  entityNameToShow = 'Network Map Details',
  entityTitle = 'Network Map',
  entityData = {},
  actions = [],
  onActionClick = () => {},
  onViewSchema,
}: NetworkMapDetailsPageContainerProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        bgcolor: 'background.paper',
        borderLeft: '1px solid',
        borderColor: 'divider',
      }}
    >
      {/* Header */}
      <CustomAppEntityHeader
        entityName={entityName}
        entityId={entityId}
        entityNameToShow={entityNameToShow}
        entityTitle={entityTitle}
        entityData={entityData}
        actions={actions}
        onActionClick={onActionClick}
        onViewSchema={onViewSchema}
      />

      {/* Content */}
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <NetworkMapDetailsContainer
          entityData={entityData}
          networkMapId={entityId}
          hideBorder
        />
      </Box>
    </Box>
  );
};
